import { DefaultNotification } from "./DefaultNotification";
import { NotificationTypes } from "./NotificationTypes";
import { NotificationAdapter } from "./NotificationAdapter";

export class DefaultError extends DefaultNotification {
	constructor(notificationAdapter: NotificationAdapter) {
		const message = "An error has occurred. If the problem persists, contact technical support.";
		super(notificationAdapter, NotificationTypes.ERROR, message);
	}
}
